<template>
  <SportDiscoverTeamsOrganize sport="basketball" />
</template>

<script>
/**
 * Basketball organize-match entry. Neutral ground court browse/booking runs on
 * BasketballChallengeTeam when the user selects "Neutral Ground" (via Request Game).
 */
import SportDiscoverTeamsOrganize from "@/routes/match_hub/shared/SportDiscoverTeamsOrganize.vue";

export default {
  name: "BasketballOrganizeMatch",
  components: { SportDiscoverTeamsOrganize },
};
</script>
